// AI Generated File
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    IterableDiffer,
    IterableDiffers,
    OnInit,
    Output,
} from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { SmartScrollService } from '@client/app/plugins/scroll/smart-scroll.service';
import { LabelRepo } from '@monsido/modules/endpoints/api/label.repo';
import { API_CONSTANTS } from '@client/app/core/constants/api.constant';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import {
    FormImportGroupRulesComponent,
} from '@client/app/forms/domain/steps/domain_groups/steps/rules/import/form-import-group-rules.component';

@Component({
    selector: 'form-domain-groups-rules',
    templateUrl: './rules.component.html',
    standalone: false,
})
export class FormDomainGroupsRulesComponent implements OnInit {
    @Input() domainGroup: any = {};
    @Output() domainGroupChange: EventEmitter<any> = new EventEmitter<any>();

    isSudo: boolean = false;
    rules: any[] = [];
    labels: any[] = [];
    loadingLabels: boolean = false;
    page = 1;
    search = '';
    pageSize = API_CONSTANTS.PAGE_SIZE;

    rulesDiffer: IterableDiffer<any> | null = null;

    constructor (
        private smartScroll: SmartScrollService,
        private sessionService: SessionService,
        private labelRepo: LabelRepo,
        private monDialog: MonDialog,
        private differs: IterableDiffers,
        private cdRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit () {
        this.activate();
        this.rulesDiffer = this.differs.find(this.domainGroup.rules).create();
    }

    private activate () {
        this.isSudo = this.sessionService.isSudo;
        this.page = 1;
        this.pageSize = 10;
        this.search = '';
        this.rules = [];
        this.labels = [];

        this.getLabels();
        if (!this.domainGroup.rules) {
            this.domainGroup.rules = [];
        }

        if (this.domainGroup.rules.length === 0) {
            this.addRule();
        }
    }

    private getLabels () {
        this.loadingLabels = true;
        return this.labelRepo.getLabels().then((labels) => {
            this.labels = labels;
        }).finally(() => {
            this.loadingLabels = false;
        });
    }

    importRules () {
        const params = {
            body: FormImportGroupRulesComponent,
            size: 'sm',
            data: {
                domainGroup: this.domainGroup,
            },
            cdRef: this.cdRef,
            manualFocus: true,
        };

        this.monDialog.create(params, (ngModel) => {
            if (ngModel) {
                this.domainGroup = ngModel;
            }
        }, null);
    }

    onSearch (search: string) {
        this.page = 1;
        this.search = search;
    }

    addRule () {
        this.search = '';
        this.domainGroup.rules.push({
            match: 'full_url',
            match_rule: 'contains',
            exclude: false,
        });

        const pageNumber = this.page;
        const total = this.domainGroup.rules.length;

        if (total >= this.pageSize) {
            this.page = total % this.pageSize !== 0
                ? Math.floor(total / this.pageSize + 1)
                : total / this.pageSize;

            if (this.page > pageNumber) {
                const container = document.querySelector('.group-form-container');
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.smartScroll.scrollTo(container!, 'domainGroupsRules', 220);
            }
        }
        this.domainGroupChange.emit(this.domainGroup);
        this.cdRef.detectChanges();
    }

    onConfirmRemove (rule: any) {
        const index = this.domainGroup.rules.indexOf(rule);
        if (index !== -1) {
            this.domainGroup.rules.splice(index, 1);
        }
    }

    trackByFn (index: number, item: any) {
        return index + item.text;
    }

    protected readonly filter = <T>(array: T[], predicate: ((item: T) => boolean) | Partial<T>): T[] => {
        if (typeof predicate === 'function') {
            return array.filter(predicate);
        }
        // Handle object predicate (matches properties)
        return array.filter(item =>
            Object.keys(predicate).every(key =>
                (item as any)[key] === (predicate as any)[key],
            ),
        );
    };
}
